import { usersApi } from 'entities/users';
import { toast } from 'react-toastify';
import { ICheckB2BIINInformation, ICreateKGPassport, ICreateKGPassportResponse } from './types';

const getB2BConstantsApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getB2BSalesPoints: builder.query({
      query: () => 'sales-point/b2b/sales-point/constants/',
    }),
    checkB2BIINInformation: builder.mutation<ICheckB2BIINInformation, string>({
      query: (iin) => `verification/b2b/verification/iin/${iin}`,
    }),
    createKGPassport: builder.mutation<ICreateKGPassportResponse, ICreateKGPassport>({
      query: (body) => ({
        url: 'account/b2b/users/documents/passport-kg',
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error) => {
        if (error) {
          toast.error('Не удалось создать пользователя', {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Пользователь МП создан', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [{ type: 'Users' }];
      },
    }),
  }),
});

export const { useGetB2BSalesPointsQuery, useCheckB2BIINInformationMutation, useCreateKGPassportMutation } =
  getB2BConstantsApi;
